module.exports = __webpack_public_path__ + "static/img/test.a0d69fb7.png";